import { useCallback } from 'react';
import { getInitialParam, setInitialParam } from '../utils/initialParams';

export type InitialRegion = 'US' | 'CA';

type InitialParamsSnapshot = {
  cid?: string;
  token?: string;
  tid?: string;
  player?: string;
  survey?: string;
  rawRegion?: string;
  region: InitialRegion;
  setRegion: (region: InitialRegion) => void;
  retailer?: string;
  setRetailer: (retailer: string) => void;
  storeFilter: string[];
  rid?: string;
  psid?: string;
  pid?: string;
  supplierId?: string;
  participantId?: string;
  studyId?: string;
};

const toRegion = (value: string | undefined): InitialRegion =>
  value === 'CA' ? 'CA' : 'US';

const parseStoreFilter = (value: string | undefined): string[] =>
  value
    ? value
        .split(',')
        .map((s) => s.trim().toLowerCase())
        .filter(Boolean)
    : [];

export const useInitialParamsSnapshot = (): InitialParamsSnapshot => {
  const setRegion = useCallback((region: InitialRegion) => {
    setInitialParam('region', region);
  }, []);

  const setRetailer = useCallback((retailer: string) => {
    setInitialParam('brand', retailer);
  }, []);

  const rawRegion = getInitialParam('region');

  return {
    cid: getInitialParam('cid'),
    token: getInitialParam('token'),
    tid: getInitialParam('tid'),
    player: getInitialParam('player'),
    survey: getInitialParam('survey'),
    rawRegion,
    region: toRegion(rawRegion),
    setRegion,
    retailer: getInitialParam('brand'),
    setRetailer,
    storeFilter: parseStoreFilter(getInitialParam('s')),
    rid: getInitialParam('rid'),
    psid: getInitialParam('psid'),
    pid: getInitialParam('pid'),
    supplierId: getInitialParam('supplier_id'),
    participantId: getInitialParam('participant_id'),
    studyId: getInitialParam('study_id'),
  };
};
